import React, { useEffect } from "react";
import trophy from "../../Assets/Images/trophy.svg";
import PopUp from "Components/PopUp/PopUp";
import { Button } from "Components/ui/button";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { SocketIo } from "App";

function StageWinPop({ open, setOpen, data }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { isVerified, id } = useSelector((state) => state.ProfileReducer?.user);

  useEffect(() => {
    open &&
      SocketIo.emit("joinRoom", {
        userId: id,
      });
  }, [open]);

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title={`${
        data?.isPending
          ? "Congratulations! Stage " + data?.stage + " in Review"
          : "Congratulations! Welcome to Stage" + (data?.stage + 1)
      }`}
      width={"600px"}
    >
      <div className="flex flex-col gap-2">
        <div className="flex flex-row gap-4 py-4 items-center justify-center">
          <div className="flex flex-col gap-1">
            <div className="font-N_Bold text-[20px] flex items-center gap-2">
              {!data?.isPending
                ? "Stage " + Number(data?.stage) + " Completed"
                : "Stage " + Number(data?.stage) + " in Review"}
              <span className="font-N_Roman text-[13px] text-primary">
                Challenge ID: CH#ID {`${data?.login}`}
              </span>
            </div>
            {!data?.isLive ? (
              data?.isPending ? (
                <div className="text-[15px] font-N_Roman opacity-[0.44]">
                  You're Stage {data?.stage} is in review. Moving to Stage{" "}
                  {data?.stage + 1} is Pending approval. Please wait for the
                  confirmation before proceeding.
                </div>
              ) : (
                <div className="text-[15px] font-N_Roman opacity-[0.44]">
                  You've completed Stage {data?.stage} and advanced to Stage{" "}
                  {data?.stage + 1}
                </div>
              )
            ) : isVerified ? (
              <div className="text-[15px] font-N_Roman opacity-[0.44]">
                Welcome to Stage {data?.stage + 1}
                <br />
                Stage {data?.stage + 1} is the real deal - you'll now trade with
                real money. Show us what you've got and keep up the great work!
              </div>
            ) : (
              <div className="text-[15px] font-N_Roman opacity-[0.44]">
                You've successfully completed Stage {data?.stage} and advanced
                to Stage {data?.stage + 1} of the challenge.
                <br />
                In Stage {data?.stage + 1}, you'll trade with real money. To get
                started, please upload your KYC documents for verification.
              </div>
            )}
          </div>
        </div>
        <Button
          className=" w-fit h-[40px]"
          onClick={() => {
            if (data?.isLive && !isVerified) {
              navigate(`/profile?tab=3`);
            } else {
              if (!data?.isPending) {
                if (pathname.includes("/Overview")) {
                  navigate(`/challenge/${data?.challengeId}/Rules`);
                } else {
                  navigate(`/challenge/${data?.challengeId}/Overview`);
                }
              }
            }

            setOpen(false);
          }}
        >
          {!isVerified && data?.isLive
            ? "Go to KYC Verification"
            : data?.isLive
            ? "Start Trading "
            : "Continue"}
        </Button>
      </div>
    </PopUp>
  );
}

export default StageWinPop;
